/**
 * Перетаскивание модального окна за header.
 * Работает только для type='modal'.
 */

/**
 * Инициализирует перетаскивание модального окна.
 * @param {ModalManager} manager
 */
export function makeDraggable(manager) {
    if (manager.type !== 'modal') return;

    const header = manager.modalElement.querySelector('.modal-header');

    if (header) {
        header.style.cursor = 'move';
        header.addEventListener('mousedown', manager._onMouseDown);
    } else {
        console.warn('Элемент с классом .modal-header не найден внутри modalElement.');
    }

    manager._setModalBodyScroll();
}

/**
 * @param {ModalManager} manager
 * @param {MouseEvent} event
 */
export function onMouseDown(manager, event) {
    if (event.button !== 0) return;
    if (event.target.closest('.btn')) return;
    const tagName = event.target.tagName.toUpperCase();
    const tags = ['INPUT', 'BUTTON'];
    if (tags.includes(tagName)) return;

    event.preventDefault();

    // Получаем текущее смещение из transform
    const style = window.getComputedStyle(manager.modalElement);
    const matrix = style.transform === 'none' ? null : style.transform.match(/matrix.*\((.+)\)/);
    if (matrix) {
        const values = matrix[1].split(', ');
        manager.dragOffsetX = parseFloat(values[4]);
        manager.dragOffsetY = parseFloat(values[5]);
    } else {
        manager.dragOffsetX = 0;
        manager.dragOffsetY = 0;
    }

    manager.isDragging = true;
    manager.startX = event.clientX;
    manager.startY = event.clientY;

    document.addEventListener('mousemove', manager._onMouseMove);
    document.addEventListener('mouseup', manager._onMouseUp);
}

/**
 * @param {ModalManager} manager
 * @param {MouseEvent} event
 */
export function onMouseMove(manager, event) {
    if (!manager.isDragging) return;

    const dx = event.clientX - manager.startX;
    const dy = event.clientY - manager.startY;

    manager.modalElement.style.transform = `translate(${manager.dragOffsetX + dx}px, ${manager.dragOffsetY + dy}px)`;
}

/**
 * @param {ModalManager} manager
 */
export function onMouseUp(manager) {
    manager.isDragging = false;

    document.removeEventListener('mousemove', manager._onMouseMove);
    document.removeEventListener('mouseup', manager._onMouseUp);
}
